<template>
  <component is="th"
             v-bind="$attrs"
             :class="classComputed"
             :style="styleComputed"
             @click="onClick($event)"
  >
    <slot>{{ text }}</slot>
  </component>
</template>

<script>
export default {
  name: "CTableColumnHead",
  props: {
    text: String,
    sortable: Boolean,
    width: String,
    sortField: String
  },
  data() {
    return {
      sortDir: '',
    }
  },
  computed: {
    classComputed() {
      if (this.sortable) {
        let obj = {
          'sorting': this.sortable && !this.sortDir,
          'sorting_asc': this.sortDir === 'asc',
          'sorting_desc': this.sortDir === 'desc'
        };

        return obj;
      }
      return null;
    },
    styleComputed() {
      let obj = {}
      if (this.width) {
        obj.width = this.width;
      }

      return obj;
    }
  },
  methods: {
    onClick(e) {
      if (this.sortable) {
        this.$emit('click', e, this.sortDir);
      }
    },
    getConfig() {
      return {
        text: this.text,
        sortable: this.sortable,
        width: this.width
      }
    },
    changeSortDir() {
      if (this.sortable) {
        if (this.sortDir === 'asc') {
          this.sortDir = 'desc';
        } else if (this.sortDir === 'desc') {
          this.sortDir = '';
        } else {
          this.sortDir = 'asc';
        }
      }
    },
    resetSort() {
      this.sortDir = null;
    },
    getOrderConfig() {
      if (this.sortable && this.sortDir) {
        return {
          field: this.sortField,
          dir: this.sortDir.toLowerCase() || 'asc'
        }
      } else {
        return null;
      }
    }
  },
}
</script>

<style scoped>

</style>